/**
 * Checks if the given string is safe to use as a url pathname.
 *
 * For simplicity, only allowed characters are letters, numbers, underscores and hyphens.
 *
 * @param path
 * @returns {boolean}
 */
export const isSafeUrlPath = (path: string): boolean => /^[a-zA-Z0-9_-]*$/.test(path);
